import { FilterComponentProps } from 'ui/components/Table'

import { InternalTransferTableFilterValue } from '../../../../types'

export type FilterProps = FilterComponentProps<InternalTransferTableFilterValue> & {
  statuses: {
    [key: string]: string
  }
}
